$(function(){
	$(".p-switch_area, .p-area__toggle").on('click', function(){
		$(this).closest(".p-area").find(".js-toggle-1").toggle("0.2s", function(){
			if ($(this).is(':visible')) {
				$(this).closest(".p-area").find(".p-area__toggle").text("-");
			} else {
				$(this).closest(".p-area").find(".p-area__toggle").text("+");
			}
		});
	});
	
	
	$(".p-prefecture__toggle").on('click', function(){
		$(this).closest(".p-prefecture").find(".js-toggle-2").toggle("0.2s", function(){
			if ($(this).is(':visible')) {
				$(this).closest(".p-prefecture").find(".p-prefecture__toggle").find('img').addClass("f-reverced");
			} else {
				$(this).closest(".p-prefecture").find(".p-prefecture__toggle").find('img').removeClass("f-reverced");
			}
		});
	});
	
	$(".pg-service_toggle_button").on('click', function(){
		
		var value = $(this).data("store-type");
		var types = [];
		if(Number.isInteger(value)) {
			types = [value];
		} else {
			types = value.split(',');
		}
		var condition = $(this).data("condition") * (-1);
		$(this).data("condition", condition);
		if(condition == 1) {
			for(i in types) {
				$(".js-store-type-" + types[i]).show("0.2s");
			}
			$(this).removeClass("pg-disabled");
		} else {
			for(i in types) {
				$(".js-store-type-" + types[i]).hide("0.2s");
			}
			$(this).addClass("pg-disabled");
		}
	});
});